import { localeCodes } from '@ringcentral/rwc-utils/src/constants/locales';

export const LOCALES = {
    asterisk: 'asterisk',
    overload: 'overload',
    cimode: 'cimode',
    ...Object.values(localeCodes).reduce((accum, current) => {
        accum[current] = current;

        return accum;
    }, {}),
};

// Use en-US as a fallback, because the developers are adding new tokens only for this locale
export const FALLBACK_LANG = LOCALES[localeCodes.enUS];
